import { render } from "./serviceOverviewItemCard.vue?vue&type=template&id=b7779884&scoped=true&ts=true"
import script from "./serviceOverviewItemCard.vue?vue&type=script&lang=ts"
export * from "./serviceOverviewItemCard.vue?vue&type=script&lang=ts"

import "./serviceOverviewItemCard.vue?vue&type=style&index=0&id=b7779884&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7779884"]])

export default __exports__